import FirebaseHandlerBase from "../firebase_handler_base";
import {ISubscriptionParams} from "../firebase_const";
import {SYSTEM_EVENTS} from "../../../../events/events";
import Event from "../../../../utils/event";
import {IGamblingSessionUpdateData} from "./gambling-session_handler_interfaces";

export default class GamblingSessionHandler extends FirebaseHandlerBase {
    static CLASS = "GamblingSessionHandler";
    protected getSubscriptionParams(): ISubscriptionParams {
        return {
            eventName: `gamblingSessions/${this.serviceFactory.userService().getCID()}`,
            successCallback: this._updateGamblingSession
        };
    }

    protected getFeatureName(): string {
        return "GamblingSession";
    }

    protected getFeatureLabel(): string {
        return "GamblingSession";
    }

    protected getFallbackServiceName(): string{
        return null;
    }

    private _updateGamblingSession = (eventData: IGamblingSessionUpdateData) => {

        Event.fire(SYSTEM_EVENTS.GAMBLING_SESSION_UPDATE, eventData);
    }
}